import { cn } from "@costar-ui/cosmos";
import { ComponentPropsWithoutRef } from "react";
import { Spinner } from "./Spinner";

export const ContainerLoader = (props: ComponentPropsWithoutRef<"div">) => {
  return (
    <div role="status" className={cn("absolute inset-0 z-40", props.className)}>
      <div className="h-full w-full rounded-xl bg-[#636363] opacity-50"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner />
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
